import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { USER_EMAIL } from '../../../types';

@Injectable({ providedIn: 'root' })
export class EmailStorageService {
  readonly #cookieService = inject(CookieService);

  get(): string {
    return this.#cookieService.get(USER_EMAIL);
  }

  remove(): void {
    if (this.#cookieService.check(USER_EMAIL)) {
      this.#cookieService.delete(USER_EMAIL, '/');
    }
  }

  save(email: string): void {
    const TTL_MINUTES = 30;
    const expires = new Date();

    expires.setMinutes(expires.getMinutes() + TTL_MINUTES);
    this.#cookieService.set(USER_EMAIL, email, expires, '/');
  }
}
